export default "../css/1c5b9a0ebc7e6abf82c8700aaa20acd3.ttf";